<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
import { computed } from 'vue';
import { weekdayLabel } from '../utils/agendaBlockUtils';

const props = defineProps({
  payloads: {
    type: Array,
    default: () => [],
  },
  block: {
    type: Object,
    default: null,
  },
});

const blockValue = (camelKey, snakeKey) =>
  props.block?.[camelKey] ?? props.block?.[snakeKey];

const blockDateText = computed(() => {
  if (!props.block) return '';
  if (blockValue('blockType', 'block_type') === 'recurrent') {
    return weekdayLabel(blockValue('weekday', 'weekday'));
  }

  const start = blockValue('startsOn', 'starts_on');
  const end = blockValue('endsOn', 'ends_on') || start;
  return start === end ? start : `${start} até ${end}`;
});

const payloadDateText = payload => {
  if (payload.block_type === 'recurrent') return weekdayLabel(payload.weekday);
  if (payload.starts_on === payload.ends_on) return payload.starts_on;
  return `${payload.starts_on} até ${payload.ends_on}`;
};

const rows = computed(() => {
  if (props.payloads.length) {
    return props.payloads.map(payload => ({
      key: `${payload.block_type}-${payload.weekday || payload.starts_on}-${payload.start_time}`,
      date: payloadDateText(payload),
      time: `${payload.start_time} - ${payload.end_time}`,
      type:
        payload.block_type === 'recurrent'
          ? 'Bloqueio recorrente'
          : 'Bloqueio temporário',
    }));
  }

  if (!props.block) return [];

  return [
    {
      key: `block-${props.block.id}`,
      date: blockDateText.value,
      time: `${blockValue('startTime', 'start_time')} - ${blockValue(
        'endTime',
        'end_time'
      )}`,
      type:
        blockValue('blockType', 'block_type') === 'recurrent'
          ? 'Bloqueio recorrente'
          : 'Bloqueio temporário',
    },
  ];
});
</script>

<template>
  <div class="grid gap-2 rounded-lais border border-lais-border bg-white p-3">
    <div
      v-for="row in rows"
      :key="row.key"
      class="flex items-start justify-between gap-3 rounded-lais-sm bg-lais-bg-soft px-3 py-2 text-[13px]"
    >
      <div class="min-w-0">
        <p class="font-semibold text-lais-text">{{ row.date }}</p>
        <p class="text-[12px] text-lais-text-muted">{{ row.type }}</p>
      </div>
      <p class="shrink-0 font-semibold text-lais-primary">{{ row.time }}</p>
    </div>
  </div>
</template>
